import SeriesItem from "./SeriesItem";

export default class Series {
  private data: SeriesItem[] = [];

  constructor(items?: SeriesItem[] | undefined) {
    if (items) {
      items.forEach(i => this.data.push(i));
    }
  }

  get(index: number): SeriesItem {
    return this.data[index];
  }

  add(item: SeriesItem) {
    this.data.push(item);
  }

  map<T>(mapFunction: (arg: SeriesItem) => T): T[] {
    return Array.from(this.data.values()).map(mapFunction);
  }

  sort(sortFunction: (arg1: SeriesItem, arg2: SeriesItem) => number): SeriesItem[] {
    return Array.from(this.data.values()).sort(sortFunction);
  }

  filter<T>(filterFunction: (arg: SeriesItem) => boolean): Series {
    return new Series(Array.from(this.data.values()).filter(filterFunction));
  }

  forEach(forEachFunction: (arg: SeriesItem, index: number) => void): void {
    return Array.from(this.data.values()).forEach(forEachFunction);
  }

}
